// (c) Copyright Ascensio System SIA 2009-2025
//
// This program is a free software product.
// You can redistribute it and/or modify it under the terms
// of the GNU Affero General Public License (AGPL) version 3 as published by the Free Software
// Foundation. In accordance with Section 7(a) of the GNU AGPL its Section 15 shall be amended
// to the effect that Ascensio System SIA expressly excludes the warranty of non-infringement of
// any third-party rights.
//
// This program is distributed WITHOUT ANY WARRANTY, without even the implied warranty
// of MERCHANTABILITY or FITNESS FOR A PARTICULAR  PURPOSE. For details, see
// the GNU AGPL at: http://www.gnu.org/licenses/agpl-3.0.html
//
// You can contact Ascensio System SIA at Lubanas st. 125a-25, Riga, Latvia, EU, LV-1021.
//
// The  interactive user interfaces in modified source and object code versions of the Program must
// display Appropriate Legal Notices, as required under Section 5 of the GNU AGPL version 3.
//
// Pursuant to Section 7(b) of the License you must retain the original Product logo when
// distributing the program. Pursuant to Section 7(e) we decline to grant you any rights under
// trademark law for use of our trademarks.
//
// All the Product's GUI elements, including illustrations and icon sets, as well as technical writing
// content are licensed under the terms of the Creative Commons Attribution-ShareAlike 4.0
// International. See the License terms at http://creativecommons.org/licenses/by-sa/4.0/legalcode

export const globalColors = {
  white: "#ffffff",
  black: "#333333",
  darkBlack: "#000",

  grayLight: "#F8F9F9",
  darkGrayLight: "#282828",
  lightGrayHover: "#F3F4F4",
  lightDarkGrayHover: "#3D3D3D",
  grayLightMid: "#ECEEF1",
  grayDarkMid: "#242424",
  lightGraySelected: "#DFE2E3",
  grayStrong: "#D0D5DA",
  grayDarkStrong: "#474747",
  gray: "#A3A9AE",
  grayDark: "#858585",
  lightGrayDark: "#657077",
  darkGrayDark: "#ADADAD",
  grayText: "#555F65",
  grayDarkText: "#5C5C5C",

  lightBlueMain: "#4781D1",
  lightBlueMainHover: "rgba(71, 129, 209, 0.85)",
  lightBlueMainDisabled: "rgba(71, 129, 209, 0.6)",
  lightBlueMainPressed: "#4074bc",
  lightSecondMain: "#5299E0",
  lightSecondMainHover: "rgba(82, 153, 224, 0.85)",
  lightSecondMainDisabled: "rgba(82, 153, 224, 0.6)",
  lightBlueAction: "#E4ECF8",
  darkGreyAction: "#515151",
  lightBlueHover: "#BED3EF",
  darkGreyHover: "#7B7B7B",

  lightActive: "#F2F6FC",
  darkActive: "#414141",

  mainGreen: "#2DB482",
  secondGreen: "#22C386",
  secondGreenDark: "#2E5E4C",
  mainOrange: "#F97A0B",
  secondOrange: "#FF9933",
  mainRed: " #F2675A",
  mainPurple: "#533ED1",
  purple: "#6D4EC2",
  secondPurple: "#8570BD",
  secondPurpleDark: "#544C6A",
  mainBlueLight: "#13B7EC",
  secondBlue: "#11A3D4",
  mainYellow: "#FFD30F",

  blurLight: "rgba(6, 22, 38, 0.2)",
  blurDark: "rgba(27, 27, 27, 0.6)",

  lightErrorStatus: "#F24724",
  darkErrorStatus: "#E06451",

  favoritesStatus: "#EDC409",
  favoriteStatusDark: "#A38A1A",
  lightStatusWarning: "#ED7309",
  darkStatusWarning: "#E17415",
  lightStatusPositive: "#35AD17",
  darkStatusPositive: "#3BA420",

  lightIcons: "#3B72A7",
  darkIcon: "#E6E6E6",
  link: "#316DAA",
  darkLink: "#E06A1B",
  blueLightMid: "#265A8F",
  bigGrayDarkMid: "#B5B5B5",

  lightToastDone: "#E3F7BE",
  darkToastDone: "#9DE051",
  lightToastInfo: "#F8F7BF",
  darkToastInfo: "#E0D751",
  lightToastAlert: "#F7E6BE",
  darkToastAlert: "#E0B151",
  lightToastWarning: "#F7CDBE",
  darkToastWarning: "#E07751",

  loader: "rgba(0, 0, 0, 0.05)",
  dndColor: "rgba(229, 228, 138, 0.5)",
  dndDarkColor: "rgba(229, 228, 138, 0.12)",
  dndHoverColor: "rgba(204, 202, 102, 0.5)",
  dndDarkHover: "rgba(204, 184, 102, 0.2)",

  onWhiteColor: "rgba(0, 0, 0, 0.1)",
  onBlackColor: "rgba(255, 255, 255, 0.1)",
  boxShadowColor: "#040F1B14",
  boxShadowDarkColor: "#040F1B29",
  loaderLight: "#E7E7E7",
  loaderDark: "#484848",

  editorGreenColor: "#40865C",
  editorBlueColor: "#446995",
  editorOrangeColor: "#B26A54",
  editorRedColor: "#AA5251",
  windowsColor: "#4C83CD",
  linuxColor: "#F4BB40",
  androidColor: "#A8D548",
  moonstone: "#35A5D2",
  //

  tickColor: "#20D21F",
  redRomb: "#FF6F3D",
  blueRomb: "#5DC0E8",
  greenRomb: "#95C038",
  tapHighlight: "rgba(0, 0, 0, 0)",
  badgeShadow: "rgba(4, 15, 27, 0.16)",
  popupShadow: "rgba(4, 15, 27, 0.08)",
  menuShadow: "rgba(4, 15, 27, 0.04)",
  lightScroll: "rgba(6, 22, 38, 0.16)",
  lightScrollHover: "rgba(6, 22, 38, 0.32)",
  lightScrollActive: "rgba(6, 22, 38, 0.5)",
  darkScroll: "rgba(136, 136, 136, 0.4)",
  darkScrollHover: "rgba(136, 136, 136, 0.64)",
  darkScrollActive: "rgba(136, 136, 136, 0.8)",

  //
  silver: "rgba(200, 200, 200, 0.2)",
  highlandGray: "rgba(11, 11, 11, 0.7)",
  alphaGreenLight: "rgba(53, 173, 23, 0.1)",
  alphaGreenDark: "rgba(59, 164, 32, 0.1)",
  alphaRedLight: "rgba(242, 28, 14, 0.1)",
  alphaRedDark: "rgba(224, 100, 81, 0.1)",

  logoColors: [
    "#FF6680",
    "#FF8F40",
    "#F2D230",
    "#61C059",
    "#1FCECB",
    "#5CC3F7",
    "#6191F2",
    "#7757D9",
    "#FF7FD4",
  ],

  lightEditorBackground: "#F3F3F3",
  darkEditorBackground: "#222222",
};
